export const SERVICE_TITLE_PREFIX = "Launch a";

export function stripServiceTitlePrefix(title?: string | null): string {
	const value = (title ?? "").replace(/\s+/g, " ").trim();
	return value.replace(/^launch\s+(?:your|a)\b\s*/i, "").trimStart();
}

/** Removes trailing LTO headline suffix if pasted into the editable title field. */
export function stripServiceTitleLtoSuffix(title?: string | null): string {
	const value = (title ?? "").replace(/\s+/g, " ").trim();
	return value.replace(/\s+within\s+\d+\s+days?\s*$/i, "").trimEnd();
}

/** Strips prefix/suffix patterns without trimming ends — safe on every keystroke. */
export function stripServiceTitleForEditingLive(title?: string | null): string {
	let value = (title ?? "").replace(/\s+/g, " ");
	value = value.replace(/^launch\s+(?:your|a)\b\s*/i, "").trimStart();
	value = value.replace(/\s+within\s+\d+\s+days?\s*$/i, "");
	return value;
}

/** Middle segment only: no "Launch a" prefix or "within N days" suffix. */
export function stripServiceTitleForEditing(title?: string | null): string {
	return stripServiceTitleForEditingLive(title).trim();
}

export function formatServiceDisplayTitle(title?: string | null): string {
	const cleanTitle = stripServiceTitlePrefix(title);
	return cleanTitle ? cleanTitle.charAt(0).toUpperCase() + cleanTitle.slice(1) : "";
}

export function servicePageTitleWithPrefix(
	title?: string | null,
	options?: { quoteMiddle?: boolean },
): string {
	const cleanTitle = formatServiceDisplayTitle(title);
	if (!cleanTitle) return SERVICE_TITLE_PREFIX;
	if (options?.quoteMiddle) {
		return `${SERVICE_TITLE_PREFIX} "${cleanTitle}"`;
	}
	return `${SERVICE_TITLE_PREFIX} ${cleanTitle}`;
}

type ServiceTitlePackage = {
	dueDays?: number | null;
};

type ServicePathInput = {
	_id?: string | null;
	slug?: string | null;
};

export function basicPackageDeliveryDays(packages?: ServiceTitlePackage[] | null): number | null {
	const rawDays = Number(packages?.[0]?.dueDays);
	if (!Number.isFinite(rawDays) || rawDays <= 0) return null;
	return Math.round(rawDays);
}

export function servicePageSeoTitleWithBasicDelivery(
	title?: string | null,
	packages?: ServiceTitlePackage[] | null,
): string {
	const days = basicPackageDeliveryDays(packages);
	const pageTitle = servicePageTitleWithPrefix(title, {
		quoteMiddle: days !== null,
	});
	if (days === null) return pageTitle;
	return `${pageTitle} within ${days} day${days === 1 ? "" : "s"}`;
}

export function servicePublicPath(service: ServicePathInput): string {
	const segment = service.slug?.trim() || service._id?.trim() || "";
	return `/services/${segment}`;
}
